export async function getSignerAddress(signer) {
    const address = await signer.getAddress();
    return address;
}
